import { CheckoutAbTestMetricToOptimize } from "@redotech/redo-conversion-core-common/checkouts/checkout-ab-test-builder";
import { SplitLibrarySplitKind } from "@redotech/redo-conversion-core-common/checkouts/splits/split-library";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum ExecuteCheckoutSplitAgentMode {
  FROM_PREDEFINED_SPLIT = "FROM_PREDEFINED_SPLIT",
  FROM_CUSTOM_DESCRIPTION = "FROM_CUSTOM_DESCRIPTION",
}

export const executeCheckoutSplitAgent = {
  name: "executeCheckoutSplitAgent" as const,
  input: z.union([
    z.object({
      mode: z.literal(ExecuteCheckoutSplitAgentMode.FROM_PREDEFINED_SPLIT),
      splitKind: createEnum(SplitLibrarySplitKind),
    }),
    z.object({
      mode: z.literal(ExecuteCheckoutSplitAgentMode.FROM_CUSTOM_DESCRIPTION),
      name: z.string(),
      description: z.string(),
      metric: createEnum(CheckoutAbTestMetricToOptimize),
    }),
  ]),
  output: z.null(),
};
